import { observer } from 'mobx-react-lite';
import { FC } from 'react';

import { useTranslation } from '@gem/modules/i18n';
import { ICommonPopupsProps, Popup } from '@gem/popups';

import { GroupForm } from '../../components/GroupForm/GroupForm';
import { useCloseFormPopup } from '../../hooks/useCloseFormPopup';
import { useCreateSpaceGroupPopupPresenter } from './CreateSpaceGroupPopup.presenter';

export const CreateSpaceGroupPopup: FC<ICommonPopupsProps> = observer((props) => {
  const { t } = useTranslation();
  const presenter = useCreateSpaceGroupPopupPresenter(props);
  const closeForm = useCloseFormPopup(props, t('cancel_channel_creation_alert'));

  return (
    <Popup
      isOpened
      onClose={closeForm.closePopup}
    >
      <GroupForm
        title={t('new_group_chat')}
        initialValues={presenter.initialValues}
        isShowMembers={false}
        onSubmit={presenter.onSubmit}
        onFormStateChange={closeForm.onFormStateChange}
        onClose={closeForm.closePopup}
      />
    </Popup>
  );
});
